module.exports = __webpack_public_path__ + "img/eg.72564b7b.svg";